const translations = {
  // Navbar
  nav_home: 'Accueil',
  nav_products: 'Produits',
  nav_contact: 'Contactez-nous',
  nav_quote: 'Obtenir un devis',

  // Hero
  hero_tagline: 'MAX SailS',
  hero_title: 'Bienvenue',
  hero_subtitle: 'Des voiles de qualité à des prix attractifs — conçues pour les marins qui exigent qualité et excellence.',
  hero_cta_quote: 'Obtenir un devis',
  hero_cta_products: 'Produits',

  // About Teaser
  about_label: 'Produits',
  about_title_1: 'Fournisseur de',
  about_title_2: 'Voiles',
  about_p1: 'MAX Sails Canada est fier de servir la communauté nautique mondiale. Nous combinons l\'artisanat traditionnel et les matériaux modernes pour livrer des voiles performantes et durables.',
  about_p2: 'Que vous soyez un plaisancier du week-end ou un régatier compétitif, nous pouvons fournir la voile adaptée à votre bateau.',
  about_p3: 'Nos clients vont des particuliers aux écoles de voile, clubs, hôtels et complexes touristiques du monde entier.',
  about_cta: 'Voir nos produits',

  // Why Us
  whyus_label: 'Pourquoi nous choisir',
  whyus_title_1: 'Fondé sur',
  whyus_title_2: 'l\'Artisanat',
  whyus_desc: 'Choisir MAX Sails Canada, c\'est choisir une équipe qui se soucie vraiment de votre expérience en mer.',
  whyus_email_btn: 'Écrivez-nous',
  whyus_r1_title: 'Matériaux de qualité',
  whyus_r1_desc: 'Nos voiles utilisent des matériaux et des accessoires haut de gamme pour garantir durabilité, longévité et performance.',
  whyus_r2_title: 'Prix attractifs',
  whyus_r2_desc: 'Des voiles de qualité n\'ont pas à coûter une fortune. Nous offrons des prix compétitifs sans compromis sur le savoir-faire.',
  whyus_r3_title: 'Délais rapides',
  whyus_r3_desc: 'Nous respectons votre saison de navigation. Notre équipe travaille efficacement pour vous livrer vos voiles quand vous en avez besoin.',

  // Contact Banner
  banner_title: 'Prêt à prendre la mer ?',
  banner_subtitle: 'Contactez-nous dès aujourd\'hui pour un devis gratuit sur votre prochaine voile.',
  banner_send: 'Envoyer un message',

  // Products Page
  products_hero_label: 'MAX Sails Canada',
  products_hero_title: 'Nos Produits',
  products_hero_subtitle: 'Des voiles de qualité pour chaque marin — du plaisancier du week-end au régatier compétitif.',
  products_section_label: 'Ce que nous offrons',
  products_section_title: 'Voiles pour la plupart des bateaux et budgets',
  products_section_desc: 'Chaque voile que nous fournissons est fabriquée selon des spécifications exactes.',
  products_cta: 'Demander un devis',

  // Product cards
  prod1_cat: 'Grand-voiles',
  prod1_title: 'Grand-voile de performance',
  prod1_desc: 'Conçue pour la vitesse et la durabilité. Nos grand-voiles sont coupées avec précision pour une rétention de forme optimale dans toutes les conditions de vent.',
  prod1_tag1: 'Course',
  prod1_tag2: 'Croisière',

  prod2_cat: 'Voiles d\'avant',
  prod2_title: 'Génois & Foc',
  prod2_desc: 'Des drifters en air léger aux focs de gros temps, nous fabriquons des voiles d\'avant qui équilibrent puissance et contrôle à tous les allures.',
  prod2_tag1: 'Génois',
  prod2_tag2: 'Foc',
  prod2_tag3: 'Enrouleur',

  prod3_cat: 'Spinnakers',
  prod3_title: 'Spinnaker asymétrique',
  prod3_desc: 'Maximisez vos performances au portant avec un spinnaker asymétrique sur mesure. Léger, coloré et conçu pour voler.',
  prod3_tag1: 'Portant',
  prod3_tag2: 'Course',

  prod4_cat: 'Voiles de croisière',
  prod4_title: 'Jeu de voiles de croisière',
  prod4_desc: 'Ensembles de voiles complets pour les marins de croisière. Robustes, fiables et faciles à manœuvrer — conçus pour les longues traversées.',
  prod4_tag1: 'Croisière',
  prod4_tag2: 'Dacron',

  prod5_cat: 'Voiles de tempête',
  prod5_title: 'Tourmentin & Trinquette de tempête',
  prod5_desc: 'Quand les conditions deviennent sérieuses, vous avez besoin de voiles en qui vous pouvez avoir confiance. Nos voiles de tempête sont fabriquées en tissu lourd avec des coins renforcés.',
  prod5_tag1: 'Sécurité',
  prod5_tag2: 'Gros temps',

  // ILCA Section
  ilca_label: 'Inventaire GRAND VOLUME',
  ilca_title: 'Inventaire de voiles ILCA / Laser',
  ilca_subtitle: 'Nous avons en inventaire les trois tailles de gréement ILCA — du gréement léger pour jeunes au gréement standard compétitif.',
  ilca_rec_use: 'Utilisation recommandée',
  ilca_mat_weight: 'Poids du tissu',
  ilca_badge_youth: 'Gréement Jeune',
  ilca_badge_radial: 'Gréement Radial',
  ilca_badge_full: 'Gréement Complet',
  ilca_use_youth: 'Jeunes / Poids léger',
  ilca_use_mid: 'Intermédiaire / Standard',
  ilca_use_full: 'Gréement complet / Compétition',

  ilca_training_title: 'Voiles d\'entraînement spécifiques',
  ilca_training_desc: 'Les voiles d\'entraînement sont un article à grand volume car elles permettent aux marins de préserver leurs voiles coûteuses « homologuées » pour les jours de course.',
  ilca_t1_label: 'Voiles d\'entraînement ILCA-4 (3,8 oz)',
  ilca_t1_desc: 'Haute durabilité pour les programmes jeunesse.',
  ilca_t2_label: 'Voiles d\'entraînement ILCA-6 (3,8 oz)',
  ilca_t2_desc: 'La taille « Radial » la plus courante pour la course en club et l\'entraînement.',
  ilca_t3_label: 'Voiles d\'entraînement ILCA-7 (4,9 oz)',
  ilca_t3_desc: 'Le tissu « Standard » plus lourd, conçu pour supporter la tension plus élevée du mât de taille complète.',

  // Contact Page
  contact_hero_label: 'Prenez contact',
  contact_hero_title: 'Contactez-nous',
  contact_reach_label: 'Nous joindre',
  contact_reach_title_1: 'Nous serions ravis',
  contact_reach_title_2: 'de vous entendre',
  contact_reach_desc: 'Une question sur une voile, besoin d\'un devis ? Envoyez-nous un message ou appelez-nous\u00a0',
  contact_phone_label: 'Téléphone',
  contact_email_label: 'Courriel',
  contact_fname: 'Prénom',
  contact_lname: 'Nom de famille',
  contact_email_field: 'Courriel',
  contact_phone_field: 'Téléphone (optionnel)',
  contact_service: 'Service requis',
  contact_service_placeholder: 'Sélectionnez un service...',
  contact_service_1: 'Voile sur mesure',
  contact_service_2: 'Voiles en stock',
  contact_service_3: 'Commande en volume',
  contact_message: 'Message',
  contact_message_placeholder: 'Parlez-nous de votre projet de voile ou de votre question...',
  contact_submit: 'Envoyer le message',
  contact_sending: 'Envoi en cours...',
  contact_success_title: 'Message envoyé !',
  contact_success_desc: 'Merci de nous avoir contactés. Nous vous répondrons dans les plus brefs délais.',

  // Custom lettering
  custom_label: 'Commandes spéciales',
  custom_title: 'Lettrage & numérotation personnalisés',
  custom_desc: 'Personnalisez votre voile avec un lettrage et une numérotation sur mesure — disponibles sur commande spéciale. Numéros de voile, noms de bateau, logos de club et plus encore, appliqués avec précision pour un rendu professionnel.',
  custom_cta: 'Demander une commande personnalisée',

  // Footer
  footer_desc: 'Des voiles de qualité à des prix attractifs.\u00a0',
  footer_nav_title: 'Navigation',
  footer_contact_title: 'Contact',
  footer_copyright: '© 2026 MAX Sails Canada. Tous droits réservés.',
};

export default translations;
